(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-finder-b2b"]) return;
  try {
    

	$(document).ready(function() {

		// Progress through each step
		$('body').on('click', '.jq-progress', function(){

			// Add the selected class to this item
			$(this).addClass('gift-selected');

			// Fade out this section and in with next
			$(this).parent().addClass('hidden');
			$(this).parent().next('div').removeClass('hidden');

			var parentID = $(this).parent().attr('id');
			parentID = parseInt(parentID.replace('jq-gf-step-', ''));

			// Get the base URL we are dealing with
			var currentURL = $('.jq-gf-btn-view-results').attr('href');

			var newURL = currentURL;
			if ($(this).text() != "I Don't Mind" && $(this).text() != "Next") {
				if (parentID > 2){ 
					newURL = newURL + ' AND ' 
				}
				newURL = newURL + '"' + $(this).text() + '"';
			}

			// Now update the URL
			$('.jq-gf-btn-view-results').attr('href',newURL);

			// Check if on final step and enable view results button if so 
			if (parentID == 3){ 
				$('.jq-gf-btn-view-results').removeClass('gift-search-btn');
			}

			return false;
		});

		// Reset button
		$('body').on('click', '.jq-gf-btn-reset', function() {

			// Reset all selected options
			$('.jq-progress').removeClass('gift-selected');

			// Hide all steps
			$('.jq-gift-step').addClass('hidden');

            // Show the first/last step again
			$('#jq-gf-step-1').removeClass('hidden'); 
			$('#jq-gf-step-4').removeClass('hidden'); 

			return false;

		});

		// Plus Button 
		$('body').on('click', '.jq-plus', function() {
			
			// Get current quantity 
			var qty = parseInt($('.jq-gf-quantity').val());
			qty = qty + 1;

			// Set new quantity
			$('.jq-gf-quantity').val(qty);

			return false;

		});

		// Minus Button 
		$('body').on('click', '.jq-minus', function() {
			
			// Get current quantity 
			var qty = parseInt($('.jq-gf-quantity').val());
			qty = qty - 1;

			if (qty < 1) {qty = 1}

			// Set new quantity
			$('.jq-gf-quantity').val(qty);

			return false;

		});

	});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-finder-b2c"]) return;
  try {
    

	$(document).ready(function() {

  // Define base URL here so we can refer back and see if it changes with gift finder options
  var baseURL = $('.jq-gf-view-results').attr('href');
  
  // Click each of the Gift Finder buttons 
  $('body').on('click', '.jq-gf-button', function(){
    $(this).parent().parent().parent().fadeOut(function() {
	  $(this).next('div').fadeIn();
    });
    
    var parentID = $(this).parent().parent().parent().attr('id');
    parentID = parseInt(parentID.replace('jq-gf-step-', ''));
    
    // Now update the URL we call
    var currentURL = $('.jq-gf-view-results').attr('href');
    
    var newURL = currentURL;
    if ($(this).text() != "I Don't Mind") {
      if (parentID > 1){ 
        newURL = newURL + ' AND ' 
      }
      newURL = newURL + $(this).text();
    }
    
    // Create HTML for tag we want to add
    var htmlTag = '<button class="gift-finder-selected jq-gf-block"><a class="giftfinder-block-text">' + parentID + ') ' + $(this).text() + '</a><span class="gift-finder-cross"><a href="#" class="jq-gift-reset">X</a></span></button>';
    
    // Add a tag 
    $('.jq-gift-tag-holder').append(htmlTag);

    if (baseURL == newURL) {
      $('.jq-gf-view-results').attr('href','https://thorntonandfrance.com/collections/best-sellers'); 
    }
    else {
      // Now update the URL
      $('.jq-gf-view-results').attr('href',newURL); 
    }

    return false;
  });
  
  // Reset button
  $('body').on('click', '.jq-gift-reset', function() {
    
    // Hide all steps
    $('.jq-gift-step').fadeOut(function() {
     	// Show the first step again
    	$('#jq-gf-step-1').fadeIn(); 
    });
    
    // Remove all tags
    $('.jq-gf-block').remove();
    
    return false;
  });
});

  } catch(e) { console.error(e); }
})();
})();
